import { Alert, Anchor, Image, List, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import SiiTimbrajeScreenshot from '@assets/sii-solicitar-timbraje.png';

const CERTIFICATION_MENU_URL =
  'https://www.sii.cl/servicios_online/1039-menu_certificacion-1184.html';

// En certificación el timbraje contra el SII no está disponible, así que los folios se piden a
// mano en el sitio del SII y se suben con "Cargar Folios". Estos pasos son el reemplazo del
// botón "Timbrar Folios".
function TestEnvFoliosInstructions() {
  return (
    <Alert
      variant="light"
      color="gray"
      my={20}
      icon={<IconInfoCircle />}
      title="Cómo obtener folios en el ambiente de pruebas"
    >
      <Text size="sm">
        En el ambiente de pruebas los folios no se piden desde acá: hay que solicitarlos en el sitio
        del SII y después subir el archivo con <b>Cargar Folios</b>.
      </Text>
      <List type="ordered" size="sm" mt="sm" spacing={4}>
        <List.Item>
          Ingresa al SII con un usuario autorizado de la empresa (necesitas certificado digital).
        </List.Item>
        <List.Item>
          Ve a <b>Factura electrónica</b> y luego a <b>Sistema de facturación de mercado</b>.
        </List.Item>
        <List.Item>
          En el menú <b>Postulantes</b>, entra a{' '}
          <Anchor href={CERTIFICATION_MENU_URL} target="_blank" rel="noreferrer" size="sm">
            Ambiente de certificación y pruebas
          </Anchor>
          .
        </List.Item>
        <List.Item>
          Abre <b>Timbraje electrónico</b> y selecciona <b>Solicitar timbraje electrónico</b>.
        </List.Item>
        <List.Item>
          Descarga el archivo de folios y súbelo aquí con <b>Cargar Folios</b>.
        </List.Item>
      </List>
      <Image
        src={SiiTimbrajeScreenshot}
        alt="Menú del SII: Sistema de facturación de mercado, Timbraje electrónico, Solicitar timbraje electrónico"
        maw={620}
        mt="md"
        radius="sm"
        style={{ border: '1px solid var(--mantine-color-gray-3)' }}
      />
    </Alert>
  );
}

export default TestEnvFoliosInstructions;
